module.exports = function(ngModule) {
  ngModule.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state('messages', {
      url: "/messages",
      template: require('./messages.html'),
      controller: require('./controller.js'),
      controllerAs: 'vm'
    });
  }])
}